import React, { useState, useEffect, useContext } from "react";
import { Container, Row, Col } from "react-bootstrap";

import "./ProductSection.css";
import ProductCard from "../../../../common/common_card/ProductCard";
import ExperiencePower from "../../../../gallary_showcase/experience_power/ExperiencePower";
import { useNavigate } from "react-router-dom";
import { getProducts } from "../../../../../utils/apis/effects/Effects";
import { IDS } from "../../../../../utils/common";
import { Context } from "../../../../../utils/context";
import HaveQuestion from "../have_question/HaveQuestion";

const prod = [
  {
    id: 1,
    title: "SQUALL CO2/ T-SHIRT CANNON",
    image: "/assets/images/effects/img1.png",
  },
  {
    id: 2,
    title: "T-SHIRT GATLING GUN",
    image: "/assets/images/effects/img2.png",
  },
  { id: 3, title: "CREEPER AQ", image: "/assets/images/effects/img3.png" },
  { id: 4, title: "DRY ICE MACHINE", image: "/assets/images/effects/img4.png" },
  { id: 5, title: "MDG Me1", image: "/assets/images/effects/img5.png" },
  { id: 6, title: "DMX PRO FAN", image: "/assets/images/effects/img6.png" },
];

export default function ProductSection({ effectId }) {
  const navigate = useNavigate();
  const [product, setProduct] = useState([]);
  const firstFour = product.slice(0, 4);
  const restProducts = product.slice(4);

  const { IMG_URL } = useContext(Context);

  const getProduct = async () => {
    if (!effectId) return;
    const res = await getProducts(effectId);
    if (res?.success) {
      setProduct(res.data);
    }
  };
  useEffect(() => {
    getProduct();
  }, [effectId]);

  const handleServiceClick = (id) => {
    navigate(`/product/${id}`);
  };

  return (
    <>
      <div className="product-page-section">
        <Container>
          <h2 className="page-title">Our Products</h2>

          <Row className="g-3">
            {firstFour?.map((item) => (
              <Col key={item.id} xl={3} lg={3} md={4} xs={6}>
                <ProductCard
                  title={item?.name}
                  image={IDS?.IMG_URL + item?.image}
                  // onClick={() => navigate("/product-details")}
                  onClick={() => handleServiceClick(item?.id)}
                />
              </Col>
            ))}
          </Row>
        </Container>
        <ExperiencePower />
        <Container>
          {restProducts.length > 0 && (
            <Row className="g-3">
              {restProducts.map((item) => (
                <Col
                  key={item?.id}
                  xl={3}
                  lg={3}
                  md={4}
                  xs={6}
                  className="custom-col"
                >
                  <ProductCard
                    title={item?.title}
                    image={IDS?.IMG_URL + item?.image}
                    // onClick={() => navigate("/product-details")}
                    onClick={() => handleServiceClick(item?.id)}
                  />
                </Col>
              ))}
            </Row>
          )}
        </Container>
      </div>
      <HaveQuestion />
    </>
  );
}
